import TextBuilder from '../Builder/Text';
export var Text = TextBuilder({
  tagName: 'p',
  className: 'text'
});